import {
  SET_ENTITY_DETAILS,
  SET_SELECTED_ENTITY_DETAILS,
  SET_ENTIIY_DETAILS_START,
  SET_ENTITY_DETAILS_FAILED,
  SET_PARENT_CLIENT_ID,
  SET_FETCH_SOCIAL_ENTITY_FINISH,
  SET_SOCIAL_ENTITY_DETAILS_FAILED,
  SET_SOCIAL_ENTIIY_DETAILS_START,
  SET_CONFIGURATION,
} from "./actionTypes";

import { envConfig, unifiedEnvConfig } from "../constants/api-endpoint";
import {
  setEntityList,
  setSocialEntityList,
  setReportsEntityList,
} from "./filters-actions";
import { fetchQualitativeSettings } from "./client-action";
import { httpGet, httpPost } from "../utility/requestHelper";
import { dispatch } from "d3";
export const fetchEntityDetails = (client_id, client_name) => {
  return (dispatch) => {
    dispatch(setEntityStart());
    dispatch(fetchSocialEntityDetails(client_id, client_name));
    dispatch(fetchQualitativeSettings(client_id));
    const clientEntityCall = httpPost(`${envConfig.ENTITIES_TO_CLIENT}`, {
      client_id: client_id,
      entity_type: "client",
    });
    const competitorEntityCall = httpPost(`${envConfig.ENTITIES_TO_CLIENT}`, {
      client_id: client_id,
      entity_type: "competitor",
    });
    const industryEntityCall = httpPost(`${envConfig.ENTITIES_TO_CLIENT}`, {
      client_id: client_id,
      entity_type: "industry",
    });

    // const socialEntitiesCall = httpGet(
    //   `${
    //     unifiedEnvConfig.FETCH_ALL_TOPICS
    //   }?client_id=${client_id}&perPage=${99999}&page=${1}`
    // );
    Promise.all([
      clientEntityCall,
      competitorEntityCall,
      industryEntityCall,
      //  socialEntitiesCall,
    ])
      .then((data) => {
        const clientEntityCallObj = data[0];
        const competitorEntiesCallObj = data[1];
        const industryEntiesCallObj = data[2];
        //   const socialEntitiesCallObj = data[3];
        const allPrintAndOnlineEntites = [];
        const printAndOnlineEntitesForReports = [];
        const socialEntitiesList = [];
        if (clientEntityCallObj.data.status == 200) {
          allPrintAndOnlineEntites.push(...clientEntityCallObj.data.result);
          printAndOnlineEntitesForReports.push(
            ...clientEntityCallObj.data.result
          );
        }
        if (competitorEntiesCallObj.data.status == 200) {
          allPrintAndOnlineEntites.push(...competitorEntiesCallObj.data.result);
          printAndOnlineEntitesForReports.push(
            ...competitorEntiesCallObj.data.result
          );
        }
        if (industryEntiesCallObj.data.status == 200) {
          allPrintAndOnlineEntites.push(...industryEntiesCallObj.data.result);
        }
        // if (socialEntitiesCallObj.data.status == 200) {
        //   socialEntitiesList.push(...socialEntitiesCallObj.data.data);
        // }
        dispatch(setEntity(allPrintAndOnlineEntites));
        dispatch(setReportsEntityList(printAndOnlineEntitesForReports));
        // dispatch(setEntity(socialEntitiesList, "social"));
        //   dispatch(setSocialEntityList(socialEntitiesList));
        dispatch(setEntityList(allPrintAndOnlineEntites));
        dispatch(setSelectedEntity(allPrintAndOnlineEntites[0]));
      })
      .catch((e) => {
        dispatch(setEntityFailed(e));
      });
  };
};

export const fetchSocialEntityDetails = (client_id, client_name) => {
  return (dispatch) => {
    dispatch(setEntityStart(true));
    httpGet(
      `${unifiedEnvConfig.FETCH_ALL_TOPICS
      }?client_id=${client_id}&perPage=${99999}&page=${1}&topic_name=${client_name}`
    )
      .then((res) => {
        if (res && res.data && res.data.data) {
          const socialEntitiesList = res.data?.data?.data
            ? res.data.data?.data
            : res.data.data;

          dispatch(setSocialEntityList(socialEntitiesList));
          dispatch(setEntity(socialEntitiesList, "social"));
          //to save parentClientId for entity and topic id in global state
          let parentClientId = (socialEntitiesList) && socialEntitiesList[0] && socialEntitiesList[0].of_client_id;
          parentClientId = (parentClientId) ? parentClientId : client_id;
          dispatch(setParentClientId(parentClientId));
        } else {
          dispatch(setEntityFailed("error", true));
          dispatch(setParentClientId(client_id));
        }
      })
      .catch((e) => {
        setEntityFailed(e, true);
      });
  };
};

export const getData = (client_id) => {
  return (dispatch) =>
    httpGet(`${unifiedEnvConfig.LIMIT}/${client_id}`).then((res) => {
      if (res) {
        dispatch(configurationDetails(res.data.data));
        // if (metadata) {
        //   const { total_post, used_post } = res.data.data.metadata.services[0];
        //   setTotalPost(total_post ? total_post : DEFAULT_VALUE);
        //   setCurrentMonthPost(used_post);
        // }
        // if (limit_metadata) {
        //   setLimitData(
        //     limit_metadata.map(({ limit }) => {
        //       return limit;
        //     })
        //   );
        //   setUsedData(
        //     limit_metadata.map(({ used }) => {
        //       return used;
        //     })
        //   );
        // }
      }
    });
};
export const setEntity = (payload, typeCtg) => {
  let actionName = SET_ENTITY_DETAILS;
  if (typeCtg === "social") {
    actionName = SET_FETCH_SOCIAL_ENTITY_FINISH;
  }
  return {
    type: actionName,
    payload,
  };
};

export const setSelectedEntity = (payload) => ({
  type: SET_SELECTED_ENTITY_DETAILS,
  payload,
});

export const setParentClientId = (payload) => ({
  type: SET_PARENT_CLIENT_ID,
  payload,
})

export const configurationDetails = (payload) => ({
  type: SET_CONFIGURATION,
  payload: payload,
});

const setEntityStart = (isSocial) => ({
  type: isSocial ? SET_SOCIAL_ENTIIY_DETAILS_START : SET_ENTIIY_DETAILS_START,
});

const setEntityFailed = (e, isSocial) => ({
  type: isSocial ? SET_SOCIAL_ENTITY_DETAILS_FAILED : SET_ENTITY_DETAILS_FAILED,
  payload: e,
});
